import React from "react";
import Images from "../../Component/Simage";

function SmartStorage() {
  return (
    <div className="depin_smart_storage drive">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3 mb-lg-0">
          <div className="left_sec">
            {/* <img src={Images.smartStorage} className="img-fluid img_src" /> */}
            <video autoPlay muted loop className="img-fluid img_src">
              <source src={Images.smartStorage} type="video/mp4" />
            </video>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div className="ryt_sec">
            <div>
              <p className="pre-title fw-500">Smart Storage</p>
              <p className="title fw-700">Hard Drive</p>
              <p className="des fw-300 mb-0">
                By contributing spare storage on your hard drive, you enable
                AInfra Network to store media and data in a fast, secure and
                decentralized manner
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmartStorage;
